import { zoomImg } from "@q/solib-utils";
import { makeAutoObservable } from "mobx";

/**
 * multi-column
 */
const getMinCol = (colHeights) => {
    let min = 0;
    for (let i = 1; i < colHeights.length; i++) {
        if (colHeights[i] < colHeights[min]) {
            min = i;
        }
    }
    return min;
};

const multiColumn = (option, data, prevColHeights) => {
    var _c;
    // 首先计算列数
    const { colNum, colSpan } = option;
    // 实际的列宽
    const colWidth = (option.wrapWidth + colSpan) / colNum - colSpan;
    // 先缓存缩放图片的函数
    const imgResize = zoomImg({
        // 宽度需要减去内距
        width: colWidth,
        height: 'auto',
        dontZoomIn: option.dontZoomIn,
        dontZoomOut: option.dontZoomOut,
    });
    // 用来记录列高
    const colHeights = prevColHeights !== null && prevColHeights !== void 0 ? prevColHeights : Array(colNum).fill(-colSpan);
    const result = [];
    const wrapMaxHeight = (_c = option.wrapMaxHeight) !== null && _c !== void 0 ? _c : Infinity;
    const caclCellHeight = (h) => {
        if (option.minHeight && isFinite(option.minHeight) && h < option.minHeight) {
            return option.minHeight;
        }
        if (option.maxHeight && option.maxHeight > 0 && h > option.maxHeight) {
            return option.maxHeight;
        }
        return Math.round(h);
    };
    // 循环数据生成瀑布流尺寸表
    data.every(({ width, height }) => {
        const minCol = getMinCol(colHeights);
        // 经过缩放后的图片高度
        let cellHeight;
        if (width === 'auto') {
            // 宽度为 auto，说明不需要缩放图片，直接使用传入高度
            // 为保持逻辑一致，此处也会加上内距
            cellHeight = caclCellHeight(height);
        }
        else {
            // 需要先对图片进行缩放
            const imgSize = imgResize({ width, height });
            // 计算图片高度后需要再加上内距，才是真正的单元格高度
            cellHeight = caclCellHeight(imgSize.height);
        }
        result.push({
            left: minCol * (colWidth + colSpan),
            top: colHeights[minCol] + colSpan,
            width: colWidth,
            height: cellHeight,
            column: minCol,
        });
        colHeights[minCol] += cellHeight + colSpan;
        // 如果已经到达了最大列高，则中止计算
        return colHeights[minCol] < wrapMaxHeight;
    });
    return { result, colHeights };
};

export class MultiColumn {
  colHeights: number[];
  maxColHeight = 0;
  colWidth = 0;
  colSpan = 0;
  wrapWidth = 0;

  constructor(cw = 318, cs = 12, ww = 0) {
    makeAutoObservable(this);
    this.colWidth = cw;
    this.colSpan = cs;
    this.wrapWidth = ww;
  }

  setWrapWidth(w: number) {
    this.wrapWidth = w;
  }

  calcColumns(data: { width: number; height: number }[]) {
    const oldColHeights = this.colHeights || (new Array(this.colNum)).fill(0);
    const {
      colHeights,
      result,
    } =  multiColumn({
      wrapWidth: this.wrapWidth,
      colWidth: this.colWidth,
      colSpan: this.colSpan,
      colNum: this.colNum,
    }, data, [...oldColHeights]);

    this.colHeights = colHeights;
    this.maxColHeight = Math.max.apply(Math, colHeights);

    return result;
  }

  renewColumns() {
    this.colHeights = null;
    this.maxColHeight = 0;
  }

  get minCols() {
    let minCols = 4;
    if (this.wrapWidth <= 320) {
      minCols = 1;
    } else if (this.wrapWidth <= 600) {
      minCols = 2;
    } else if (this.wrapWidth <= 900) {
      minCols = 3;
    }
    return minCols;
  }

  get colNum() {
    return Math.max(Math.floor((this.wrapWidth + this.colSpan) / (this.colWidth + this.colSpan)), this.minCols);
  }
}